import {date} from './Date/sl'

export const general = {
  ...date,
}
